export default __webpack_public_path__ + "static/media/test connection.98a1d957.svg";